


export interface ReducedParams {
	dateFrom: string,
	dateTo: string,
	customerId?: string,
	dc?: string,
	materialId?: string,
	region?: string,
	district?: string,
	orderPhase?: string,
}



export enum OrderPhaseEnum {
	any = 0,
	planning = 10,
	execution = 20,
}